export enum CookieBannerVariant {
  FILE_VIEWER = 'FILE_VIEWER',
  COMMUNITY = 'COMMUNITY',
  AUTH = 'AUTH',
  PROTOTYPE = 'PROTOTYPE',
}
